import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { Gauge, SocialNetworkIcon } from 'components';
import humanFormat from 'human-format';
import * as styles from './AdStep2Preview.scss';
import AnimatedNumber from 'react-animated-number';
var numberFormatScale = new humanFormat.Scale({
  '': 1,
  k: 1000,
  M: 1000000,
  B: 1000000000,
  T: 1000000000000
});
var AdStep2Preview = (_dec = connect(function (state) {
  var selector = formValueSelector('adForm');
  return {
    isFetchingAudience: state.ads.fetchingAudienceData
  };
}, {}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(AdStep2Preview, _Component);

  var _super = _createSuper(AdStep2Preview);

  function AdStep2Preview(props) {
    _classCallCheck(this, AdStep2Preview);

    return _super.call(this, props);
  }

  _createClass(AdStep2Preview, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
        className: styles.previewTitle
      }, "Audience Definition ", this.props.isFetchingAudience && /*#__PURE__*/React.createElement("i", {
        className: "fa fa-circle-o-notch fa-spin"
      })), !this.props.incalculable ? /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          opacity: this.props.isFetchingAudience ? 0.5 : null
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12 col-lg-5"
      }, /*#__PURE__*/React.createElement("p", {
        style: {
          textAlign: 'center',
          color: '#8b8b8b'
        }
      }, "Potential Audience"), /*#__PURE__*/React.createElement("h1", {
        style: {
          fontWeight: 'bold',
          fontSize: '40px',
          textAlign: 'center',
          color: '#434343',
          marginBottom: 0
        }
      }, /*#__PURE__*/React.createElement(AnimatedNumber, {
        component: "text",
        value: this.props.potentialAudience,
        className: styles.potentialAudienceNumber,
        initialValue: 0,
        duration: 600,
        formatValue: function formatValue(n) {
          return humanFormat(n, {
            scale: numberFormatScale
          });
        }
      })), /*#__PURE__*/React.createElement("p", {
        style: {
          textAlign: 'center',
          color: '#434343'
        }
      }, "People")), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12 col-lg-7"
      }, /*#__PURE__*/React.createElement("ul", {
        className: styles.list
      }, this.props.locations.length > 0 && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
        className: styles.listLabel
      }, "Location - Living In:"), this.props.locations.join(', ')), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
        className: styles.listLabel
      }, "Age:"), this.props.age ? this.props.age : "".concat(this.props.minAge, " - ").concat(this.props.maxAge)), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
        className: styles.listLabel
      }, "Gender:"), this.props.genders.length ? this.props.genders.map(function (g) {
        return g === 'Male' ? 'Men' : 'Women';
      }).join(', ') : 'Everyone'), this.props.adPlacements.length > 0 && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
        className: styles.listLabel
      }, "Placements:"), this.props.adPlacements.join(', ')), this.props.includedInterestLines.length > 0 && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
        className: styles.listLabel
      }, "People Who Match:"), this.props.includedInterestLines.join(', ')), this.props.excludedLines.length > 0 && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
        className: styles.listLabel
      }, "Exclude:"), this.props.excludedLines.join(', ')), this.props.excludedLocations.length > 0 && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
        className: styles.listLabel
      }, "Exclude Location:"), this.props.excludedLocations.join(', '))))) : /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("p", {
        style: {
          color: 'silver',
          fontSize: 13
        }
      }, "Potential reach esitimates are not available due to your audience configuration."), /*#__PURE__*/React.createElement("p", {
        style: {
          color: 'silver',
          fontSize: 13
        }
      }, "This is most likely due to there being a Custom Audience in your targeting options.")), this.props.errorMessage && /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("p", {
        style: {
          color: 'red'
        }
      }, "".concat(this.props.errorMessage.error && this.props.errorMessage.error.message ? this.props.errorMessage.error.message : this.props.errorMessage))));
    }
  }]);

  return AdStep2Preview;
}(Component), _defineProperty(_class2, "propTypes", {
  potentialAudience: PropTypes.number,
  locations: PropTypes.array,
  minAge: PropTypes.string,
  maxAge: PropTypes.string,
  age: PropTypes.string,
  adPlacements: PropTypes.array,
  includedInterestLines: PropTypes.array,
  errorMessage: PropTypes.string,
  excludedLines: PropTypes.array,
  excludedLocations: PropTypes.array,
  genders: PropTypes.array
}), _defineProperty(_class2, "defaultProps", {
  potentialAudience: 0,
  locations: [],
  minAge: '',
  maxAge: '',
  age: '21 - 65+',
  adPlacements: [],
  includedInterestLines: [],
  errorMessage: '',
  excludedLines: [],
  excludedLocations: [],
  genders: []
}), _temp)) || _class);
export default AdStep2Preview;